"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignSummary = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'page-content-block-container';
const DesignSummary = (props) => {
    const { modificators, modifiersStep, contentSlot, summarySlot } = props;
    return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, modificators) },
        react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__content`, modifiersStep) }, contentSlot),
        react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__summary`, modifiersStep) }, summarySlot)));
};
exports.DesignSummary = DesignSummary;
//# sourceMappingURL=index.js.map